export default "__VITE_ASSET__BhcUOuVD__"